import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AuthUserHelper } from '../helpers/auth-user.helper'
import { ApiEnvironment } from '../helpers/api-environment.helper'

@Injectable()
export class AuthenticationService {
  url: string | null = null
  sideUrl: string | null = null
  responseOne: Observable<any> | null = null
  responseTwo: Observable<any> | null = null
  constructor (
    private http: HttpClient,
    private authUser: AuthUserHelper,
    private api: ApiEnvironment,
    private router: Router
  ) {
    this.url = environment.baseApiUrl
    this.sideUrl = this.getSide()
  }
  getSide () {
    return 'https://test.icashremit.com/v1/'
  }

  authenticate (data: any): Observable<any> {
    this.responseOne = this.http
      .post(`${this.api.baseUrl()}auth`, data, { withCredentials: true })
      .pipe(
        map((response: any) => {
          // The server sets the JWT in an httpOnly cookie; mark auth state client-side.
          this.authUser.markLoggedIn()
          return response
        })
      )
    return this.responseOne
  }

  forgotPassword (data: any): Observable<any> {
    this.responseOne = this.http.post(
      `${this.api.baseUrl()}forgot-password`,
      data
    )
    return this.responseOne
  }

  resetPassword (data: any, token: string): Observable<any> {
    this.responseOne = this.http.post(
      `${this.api.baseUrl()}reset-password/${token}`,
      data
    )
    return this.responseOne
  }

  logout () {
    // Clear the httpOnly cookie server-side, then drop the client-side auth state.
    this.http
      .get(`${this.api.baseUrl()}logout`, { withCredentials: true })
      .subscribe(
        () => {},
        () => {}
      )
    this.authUser.clearLoggedIn()
    this.authUser.removeToken()
    this.router.navigate(['/login'])
  }
}
